const RECENT_FONTS_KEY = 'recentFonts';

class Storage {
  value: number[];

  public getValue() {
    if (typeof localStorage === 'undefined') {
      this.value = [];
    } else if (!this.value) {
      const storedValue = localStorage.getItem(RECENT_FONTS_KEY);

      this.value = storedValue ? JSON.parse(storedValue) : [];
    }

    return this.value;
  }

  public addNewEntry(entry: number) {
    const filtered = this.value.filter((item) => item !== entry);
    const newValue = [entry, ...filtered];

    localStorage.setItem(RECENT_FONTS_KEY, JSON.stringify(newValue));
    this.value = newValue;

    return newValue;
  }
}

export default new Storage();
